export const getVoicesList = async (apiKey) => {
  const apiUrl = 'https://api.elevenlabs.io/v1/voices';
  const response = await fetch(apiUrl, {
    headers: {
      "xi-api-key": apiKey
    }
  });

  if (!response.ok) {
    throw new Error('Cannot get voices. Please make sure your API Key is correct.');
  }

  const voices = await response.json();
  return voices.voices.map((v) => ({ id: v.voice_id, name: v.name }));
};

export const textToSpeech = async (text, voiceId, apiKey) => {
  const apiUrl = `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}?optimize_streaming_latency=0&output_format=mp3_44100_128`;

  if (!voiceId) {
    throw new Error('Invalid Voice ID');
  }

  if (!text) {
    return;
  }

  const body = {
    text,
    model_id: "eleven_monolingual_v1",
    voice_settings: {
      stability: 0,
      similarity_boost: 0,
      style: 0,
      use_speaker_boost: true
    }
  }

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      "xi-api-key": apiKey,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error('Cannot generate audio. Please make sure your API Key is correct and you have enought characters left in your ElvenLabs subscription.');
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
};
